// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3978":"7790e2f3","6281":"7790e2f3"}[chunkId] + ".chunk.css";
};